export const state = {
    currentLayout: 'PatientLayout',
    currentOffice: null,
    currentDate: null,
    firebaseToken: null,
    userId: null,
    doctor: false,
    patient: false,
    patientPosition: null,
    patientPlace: '',
    patientPlaceName: '',
    patientMedicalPractice: null,
    offices: {},
    online: true,
    countries: {},
    recommendations: {},
    notifications: [],
    defaultCountryId: null,
    frontLanguage: localStorage.getItem('language') || 'en',
    languages: {},
    loaded: false,
    loading: false,
    formError: null,
    listenAppointments: false,
    onboardingStep: 0,
    preventBodyScroll: false
}



// WEBPACK FOOTER //
// ./src/store/state.js